import { get } from 'lodash';

// 0th element is chosen because function expects an array with only one object
export const getApplicationProperty = (applications, property, specificAttribute = null) => {
  if (specificAttribute) {
    return get(applications, `[0].${property}.${specificAttribute}`);
  }
  return get(applications, `[0].${property}`);
};